import { FilterValue } from "../Filters/FilterValue";
import { SortType } from "../SortType";

export enum OrderType {
  NORMAL = 1,
  UNPAID_SAMPLE = 2,
  EVENT = 3,
  STORAGE = 4,
  PAID_SAMPLE = 5,
  HYBRID = 6,
  POD = 7,
}

export interface OrdersFilters {
  page_no: number;
  search_text?: string;
  customer_id: FilterValue[];
  user_id: FilterValue[];
  admin_id: FilterValue[];
  start_date?: Date;
  end_date?: Date;
  invoiced?: boolean;
  project_created?: boolean;
  limit: number;
  sort_by: string;
  sort_type: SortType;
  list?: FilterValue[];
  order_id?: FilterValue[];
  order_type?: FilterValue[];
  order_types?: string[];
}

export const OrderTypeFilter: FilterValue[] = [
  { id: "1", value: "Active" },
  { id: "2", value: "Invoiced" },
  { id: "3", value: "Project Created" },
];
